
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class List extends Vue {
  public componentTitle = 'Titulo componente de inserir';

  public headers = [
    {
      text: 'Exemplo Varchar',
      sortable: true,
      value: 'varchar',
      align: 'left',
      type: 'varchar',
    },
    {
      text: 'Exemplo Autocomplete',
      sortable: true,
      value: 'autocomp',
      align: 'left',
      type: 'autocomplete',
      items: ['Option1', 'Option2', 'Option3'],
    },
    {
      text: 'Exemplo Bool',
      sortable: true,
      value: 'boole',
      align: 'left',
      type: 'bool',
      items: [
        { text: 'Sim', value: true },
        { text: 'Não', value: false },
      ],
    },
    {
      text: 'Exemplo Int4',
      sortable: true,
      value: 'int4',
      align: 'left',
      type: 'int4',
    },
    {
      text: 'Exemplo Numeric',
      sortable: true,
      value: 'num',
      align: 'left',
      type: 'numeric',
    },
    {
      text: 'Exemplo Timestamp',
      sortable: true,
      value: 'date',
      align: 'left',
      type: 'timestamp',
    },
    {
      text: 'Exemplo Dinheiro',
      sortable: true,
      value: 'money',
      align: 'left',
      type: 'currency',
    },
  ];

  public async mounted() {}
}
